import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCaretRightStyle0 = cosmosIconCss;

const CosmosIconCaretRight$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCaretRight extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '444752dbb8ecc5c88fc8b368ce0b1e42d073b159', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ebe7c8d14b307d12fd6c3a8dcd36463aa3eba251', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'bdd767885dc1055b7984eff3f5ca873dd114c0b8', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.79 10.79 8.51 5.51a.3.3 0 0 0-.51.21v10.56a.3.3 0 0 0 .51.21l5.28-5.28a.29.29 0 0 0 0-.42Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCaretRightStyle0; }
}, [1, "cosmos-icon-caret-right", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-caret-right"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-caret-right":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCaretRight$1);
            }
            break;
    } });
}

const CosmosIconCaretRight = CosmosIconCaretRight$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCaretRight, defineCustomElement };
